import { render, staticRenderFns } from "./DiscountOffer.vue?vue&type=template&id=deca3198"
import script from "./DiscountOffer.vue?vue&type=script&lang=js"
export * from "./DiscountOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deca3198')) {
      api.createRecord('deca3198', component.options)
    } else {
      api.reload('deca3198', component.options)
    }
    module.hot.accept("./DiscountOffer.vue?vue&type=template&id=deca3198", function () {
      api.rerender('deca3198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subscription/unsubscription/DiscountOffer.vue"
export default component.exports